<li class="dropdown-list-item" tabindex="-1">
  <div class="flex">
    <i *ngIf="type.icon" class="p-1 mr-2 material-icons md-18 {{ type.color }}  ">{{ type.icon }} </i>
    <span
      *ngIf="!type.icon"
      [ngClass]="{ 'text-red-500 font-bold': type.code === 'PEN' }"
      class="mx-2">
      {{ type.code }}
    </span>
    {{ option }}
  </div>
</li>
